module.exports = __webpack_public_path__ + "img/no-job-history.78fb4e66.svg";